




























































































import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  ref,
} from '@vue/composition-api';
import SelectII from '@/components/select-ii/select-ii.vue';
import { getCountryList, getCityList } from '@/functions/location-function';
import type { ImportedJobDetail, JsonObject } from './types';
import { locationDrafts, locationPaths, LocationOption, validLocation } from './correction-editor';

export default defineComponent({
  components: { SelectII },
  props: {
    detail: { type: Object as PropType<ImportedJobDetail>, required: true },
    disabled: Boolean,
  },
  setup(props, context) {
    const t = (key: string) => String(context.root.$t(`pages.imported-jobs.${key}`));
    const countries = ref<LocationOption[]>([]);
    const cities = ref<LocationOption[]>([]);
    const loading = ref(false);
    const error = ref(false);
    const editing = ref(false);
    const resetting = ref(false);
    const choice = reactive({ country: '', city: '', remote: false });
    const valid = computed(() => validLocation(choice, countries.value, cities.value));
    const corrected = computed(() =>
      locationPaths.some((path) =>
        Object.prototype.hasOwnProperty.call(props.detail.corrections, path)
      )
    );
    const issues = computed(() =>
      props.detail.issues.filter((issue) => !!issue.field && locationPaths.includes(issue.field))
    );
    const countryOptions = computed(() => [
      { id: '', text: '' },
      ...countries.value.map((item) => ({ id: item.id, text: item.label })),
    ]);
    const cityOptions = computed(() => [
      { id: '', text: '' },
      ...cities.value.map((item) => ({ id: item.id, text: item.label })),
    ]);
    const describe = (data: JsonObject) => {
      if (data.IsRemote === true) return t('remote');
      const country = countries.value.find((item) => item.id === data.CountryCode);
      const city = cities.value.find((item) => item.id === data.CityId);
      return (
        [country?.label || data.CountryName || data.CountryCode, city?.label || data.CityName]
          .filter(Boolean)
          .join(' / ') || t('location-missing')
      );
    };
    const load = async () => {
      loading.value = true;
      error.value = false;
      try {
        const lists = await Promise.all([getCountryList(true), getCityList(true)]);
        countries.value = lists[0];
        cities.value = lists[1];
      } catch {
        error.value = true;
      } finally {
        loading.value = false;
      }
    };
    const changed = () => {
      context.emit('change', locationDrafts(choice));
      context.emit('validity', valid.value);
    };
    const start = () => {
      const data = props.detail.effective;
      choice.country = String(data.CountryCode || '');
      choice.city = String(data.CityId || '');
      choice.remote = data.IsRemote === true;
      if (resetting.value) {
        context.emit('undo');
        context.emit('validity', true);
      }
      resetting.value = false;
      editing.value = true;
    };
    const countryChanged = (value: string) => {
      choice.country = value;
      choice.city = '';
      changed();
    };
    const cityChanged = (value: string) => {
      choice.city = value;
      changed();
    };
    const undo = () => {
      editing.value = false;
      resetting.value = false;
      context.emit('undo');
      context.emit('validity', true);
    };
    const reset = () => {
      resetting.value = true;
      context.emit('reset');
      context.emit('validity', true);
    };
    onMounted(load);
    return {
      t,
      choice,
      valid,
      corrected,
      issues,
      countryOptions,
      cityOptions,
      describe,
      load,
      loading,
      error,
      editing,
      resetting,
      start,
      changed,
      countryChanged,
      cityChanged,
      undo,
      reset,
    };
  },
});
